import { components, useApi } from "@appretio/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateCubeMutation } from "./cubeMutationInvalidation";

type RenameCubeInput = components["schemas"]["RenameCubeInput"];

/**
 * Mutation hook that renames a cube's version label. Labels feed every
 * version dropdown and the grid's producer labels, so the whole
 * versions surface is invalidated.
 */
export function useRenameCube() {
  const apiClient = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: RenameCubeInput) => {
      const response = await apiClient.POST("/v2/forecast/cubes/rename", {
        body: input
      });
      if (!response.data?.result) {
        throw new Error("Missing result in rename cube response");
      }
      return response.data.result;
    },
    onSuccess: async () => {
      await invalidateCubeMutation(queryClient, { versions: true });
    },
    meta: {
      errorMessage: "Failed to rename the version"
    }
  });
}
